<template>
  <div class="members">
    <ul>
      <li class="dis_flex dis_ali" v-for="(item, index) in dataList" :key="index">
        <div class="img">
          <img :src="item.head_img" alt />
        </div>
        <div class="intro">
          <div class="en-name">{{item.english_name}}</div>
          <div class="ch-name">{{item.name}}</div>
          <div class="info" v-html="item.introduce"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList: []
    }
  },
  mounted () {
    this.getData()

  },
  methods: {
    getData: function () {
      this.$https.fetchPost('/Leader/leader_list', {
      }).then((res) => {
        // console.log(res.data)
        this.dataList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    }
  },
  components: {
  }

}
</script>
<style lang="less">
.members {
  padding: 0 0 200px;
  li {
    border-bottom: solid 1px #eeeeee;
    padding: 55px 0;
    &:nth-child(even) {
      flex-direction: row-reverse;
      .intro {
        padding-right: 100px;
      }
    }
    &:nth-child(odd) {
      .intro {
        padding-left: 64px;
      }
    }
    .img {
      width: 230px;
      height: 230px;
      border-radius: 50%;
      background: #eeeeee;
      overflow: hidden;
    }
    .intro {
      flex: 1;
      .en-name {
        font-family: Arial-BoldMT;
        font-size: 36px;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #c9cbd5;
        font-weight: bold;
      }
      .ch-name {
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0.6px;
        color: #535353;
        font-weight: bold;
        margin: 20px 0;
      }
      .info {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Relationship/members.vue